import { FormFields, FormState, FormSteps, GMAddressField } from '@app-types/delivery';

export const FORM_STATE: FormState = {
    step: FormSteps.POSTAL_CODE_CITY,
    inseeCode: '',
    postalCode: '',
    city: '',
    streetNumber: '',
    streetName: '',
    streetId: '',
};

export const FORM_FIELDS: FormFields = {
    postalCode: {
        name: 'postalCode',
        data: [],
        value: '',
        isTouched: false,
        isSelectedFromAutocomplete: false,
        status: 'default',
        errorMessage: '',
    },
    city: {
        name: 'city',
        data: [],
        value: '',
        isTouched: false,
        isSelectedFromAutocomplete: false,
        status: 'default',
        errorMessage: '',
    },
    streetName: {
        name: 'streetName',
        data: [],
        value: '',
        isTouched: false,
        isSelectedFromAutocomplete: false,
        status: 'default',
        errorMessage: '',
    },
    streetNumber: {
        name: 'streetNumber',
        data: [],
        value: '',
        isTouched: false,
        isSelectedFromAutocomplete: false,
        status: 'default',
        errorMessage: '',
    },
};

export const GM_ADDRESS_FIELD: GMAddressField = {
    value: '',
    data: [],
    isSelectedFromAutocomplete: false,
    status: 'default',
    errorMessage: '',
};
